// styles/LeagueNameTwoLine.tsx
import React from "react";

type Props = {
  name: string;
  className?: string; // optional passthrough
};

export const LeagueNameFit: React.FC<Props> = ({ name, className }) => {
  return (
    <span
      className={["submenu-title-text", className].filter(Boolean).join(" ")}
      title={name} // show full on hover
    >
      {name}
    </span>
  );
};
